var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntinerery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.779,
    height: 24.717,
    viewBox: "0 0 31.779 24.717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-book-open",
    "data-name": "Icon awesome-book-open",
    d: "M29.915,2.253c-3.023.172-9.033.8-12.743,3.067a.848.848,0,0,0-.4.727V26.122a.873.873,0,0,0,1.284.744c3.817-1.921,9.337-2.445,12.066-2.589a1.721,1.721,0,0,0,1.656-1.692V3.946a1.73,1.73,0,0,0-1.863-1.694ZM14.606,5.32C10.9,3.049,4.887,2.425,1.864,2.253A1.73,1.73,0,0,0,0,3.946v18.64a1.72,1.72,0,0,0,1.656,1.692c2.73.143,8.253.668,12.07,2.59a.871.871,0,0,0,1.281-.743V6.036A.831.831,0,0,0,14.606,5.32Z",
    transform: "translate(0 -2.25)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntinerery);
export default __webpack_public_path__ + "static/media/intinerery.659cb045ab41c7c054fffd7b4121ede5.svg";
export { ForwardRef as ReactComponent };